import {dateFormats} from '../constants/date';
import formatDate from 'date-fns/format';
import {parseISO} from 'date-fns';
// TODO: something wrong on test
// import Bugsnag from '../../bugsnag';

export const datePipe = (date?: string | null, format = dateFormats.fullDate) => {
  if (!date) {
    return '';
  }
  try {
    return formatDate(new Date(parseISO(date)), format);
  } catch (e) {
    // Bugsnag.addMetadata('datePipe error payload', {date});
    // Bugsnag.notify(e);
    return date;
  }
};
